import React, { useContext, useEffect, useState } from "react";
import { ProductContext } from "../../context/ProductContext";

interface VideoData {
  id: string;
  title: string;
}

const VideoLink: React.FC = () => {
  const context = useContext(ProductContext);
  const [videoData, setVideoData] = useState<VideoData[]>([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const videoLinks = context?.product?.videoLinks || [];
  const headingColor = context?.product?.headingColor || "#000000";
  const textColor = context?.product?.textColor || "#000000";
  const headingFontStyle = context?.product?.headingFontStyle;
  const fontStyle = context?.product?.fontStyle;

  const extractYouTubeID = (url: string) => {
    const match = url.match(/[?&]v=([^&]+)/);
    return match ? match[1] : null;
  };

  useEffect(() => {
    const fetchVideoTitles = async () => {
      const videos = videoLinks.map(async (video) => {
        const videoId = extractYouTubeID(video.url);
        if (!videoId) return null;

        try {
          const response = await fetch(`https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`);
          const data = await response.json();
          return { id: videoId, title: data.title || "No title found" };
        } catch (error) {
          console.error("Error fetching video title:", error);
          return { id: videoId, title: "No title available" };
        }
      });

      const results = await Promise.all(videos);
      setVideoData(results.filter((v): v is VideoData => v !== null));
    };

    if (videoLinks.length > 0) {
      fetchVideoTitles();
    }
  }, [videoLinks]);

  if (videoData.length === 0) {
    return null;
  }

  return (
    <div className="w-full max-w-2xl mx-auto px-4 pb-5 font-mulish text-left">
      <h2
        style={{ letterSpacing: "0.01em", color: headingColor, fontFamily: headingFontStyle }}
        className="text-base font-bold leading-tight pb-2"
      >
        Videos
      </h2>

      <div className="overflow-x-auto mt-1">
        <div className="flex space-x-4">
          {videoData.map((video, index) => (
            <div key={index} className="flex-none w-48">
              <a href={`https://www.youtube.com/watch?v=${video.id}`} target="_blank" rel="noopener noreferrer">
                <img
                  src={`https://img.youtube.com/vi/${video.id}/0.jpg`}
                  alt={video.title}
                  className="w-full h-auto rounded-md object-cover aspect-video"
                />
              </a>
              <p style={{color: textColor, fontFamily: fontStyle}} className="text-xs text-center mt-1">{video.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoLink;
